import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslocoPipe} from "@jsverse/transloco";

import {BookingService} from '../../services/booking/booking.service';
import {Booking} from '../../../core/entities/booking/booking.entity';
import {
  CreateBookingModalComponent
} from '../../components/bookings/create-booking-modal/create-booking-modal.component';
import {BookingItemComponent} from '../../components/bookings/booking-item/booking-item.component';
import {DateTime} from 'luxon';
import {Subject, takeUntil} from 'rxjs';

@Component({
  selector: 'app-bookings',
  imports: [
    TranslocoPipe,
    CreateBookingModalComponent,
    BookingItemComponent
],
  templateUrl: './bookings.component.html',
  styleUrl: './bookings.component.scss'
})
export class BookingsComponent implements OnInit {
  public ongoingBookings: Booking[] = [];
  public pastBookings: Booking[] = [];
  public createBookingModalOpened = false;
  public loadingOngoingBookings = false;
  private readonly destroy$ = new Subject<void>();

  public constructor(
    private readonly bookingService: BookingService
  ) {
  }

  public ngOnInit() {
    this.loadBookings();
    this.bookingService.onRefreshBookings()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadBookings());
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public openCreateBookingModal(): void {
    this.createBookingModalOpened = true;
  }

  public closeCreateBookingModal(booking: Booking | null = null): void {
    if (booking !== null) {
      const now = DateTime.now();

      if (booking.datetime > now) {
        this.ongoingBookings.push(booking);
        this.ongoingBookings.sort((a, b) => a.datetime.toMillis() - b.datetime.toMillis());
      } else {
        this.pastBookings.push(booking);
        this.pastBookings.sort((a, b) => a.datetime.toMillis() - b.datetime.toMillis());
      }
    }

    this.createBookingModalOpened = false;
  }

  private loadBookings(): void {
    this.loadingOngoingBookings = true;
    this.bookingService.getOngoingBookingsOfPhotographer().subscribe(
      (bookings) => {
        this.ongoingBookings = bookings;
        this.loadingOngoingBookings = false;
      }, () => {
        this.loadingOngoingBookings = false;
      }
    );
    this.bookingService.getPastBookingsOfPhotographer().subscribe(
      (bookings) => {
        this.pastBookings = bookings;
      }, () => {
      }
    );
  }

}
